import styled from 'styled-components'
import { font, bp } from 'lib/core/resources/helpers/styled'

export const Container = styled.h2`
  font: ${font('default', 'medium', '24px/1.5')};
  text-align: center;
  color: ${props => props.theme.palette.general.strong};
  border-bottom: 1px solid ${props => props.theme.palette.general.greyDark};
  padding-bottom: 15px;
  ${bp('sm')`
    text-align: left;
  `}
`
